import React from 'react';
import { Button } from '@stockx/ui';
import AppRouterLink from './Link';
import ExternalSwitcherLink from './ExternalSwitcherLink';
import type { LinkProps } from './types';

interface Props extends LinkProps {
  external?: boolean;
  isDisabled?: boolean;
}

const sxDisabled = {
  _disabled: {
    pointerEvents: 'none',
  },
};

const ButtonLink = ({ children, to, external, ...props }: Props) => (
  <Button
    {...(to &&
      !props?.isDisabled && {
        as: external ? ExternalSwitcherLink : AppRouterLink,
      })}
    to={to}
    sx={sxDisabled}
    {...props}
  >
    {children}
  </Button>
);

export default ButtonLink;
